module.exports = __webpack_public_path__ + "/images/logo-af-pottery-barn-kids.0e8e575.svg";